export const NAV_LINKS = [
  {
    label: "Services",
    dropdown: [
      { name: "Web Development", link: "/web-development" },
      { name: "Mobile App Development", link: "/mobile-app-development" },
      { name: "AI & ML Solutions", link: "/ai-ml-solutions" },
      { name: "Cloud DevOps", link: "/cloud" },
      { name: "UI/UX Design", link: "/ui-ux" },
      { name: "E-Commerce Solutions", link: "/ecommerce" },
    ],
  },
  {
    label: "Solutions",
    dropdown: [
      { name: "CRM Solution", link: "/crm-solutions" },
      { name: "ERP Solution", link: "/erp-solutions" },
      { name: "HRM Solution", link: "/hrm-solutions" },
      { name: "LMS Solution", link: "/lms-solutions" },
      { name: "POS Solution", link: "/pos-solutions" },
      { name: "SaaS Platform", link: "/saas-platform" },
    ],
  },
  {
    label: "Industries",
    dropdown: [
      { name: "Healthcare", link: "/healthcare-solution" },
      { name: "FinTech", link: "/fintech-solution" },
      { name: "EdTech", link: "/edtech-solution" },
      { name: "Retail & E-Commerce", link: "/retail-ecommerce-solution" },
      { name: "Real Estate", link: "/realestate-solution" },
      { name: "Logistics", link: "/logistic-solution" },
    ],
  },
  { label: "Portfolio", dropdown: null, link: "/portfolio" },
  { label: "About", dropdown: null, link: "/#about" },
  { label: "Blog", dropdown: null, link: "/blogs" },
];

export const FOOTER_LINKS = {
  Services: [
    { label: "Web Development", path: "/web-development" },
    { label: "Mobile Apps", path: "/mobile-app-development" },
    { label: "AI & ML", path: "/ai-ml-solutions" },
    { label: "Cloud & DevOps", path: "/cloud" },
    { label: "UI/UX Design", path: "/ui-ux" },
    { label: "E-Commerce", path: "/ecommerce" },
  ],
  Company: [
    { label: "About Us", path: "/#about" },
    { label: "Portfolio", path: "/portfolio" },
    { label: "Blog", path: "/blogs" },
    { label: "Contact", path: "#contact" },
  ],
  Solutions: [
    { label: "CRM Solution", path: "/crm-solutions" },
    { label: "ERP Solution", path: "/erp-solutions" },
    { label: "HRM Solution", path: "/hrm-solutions" },
    { label: "LMS Solution", path: "/lms-solutions" },
    { label: "POS Solution", path: "/pos-solutions" },
    { label: "SaaS Platform", path: "/saas-platform" },
  ],
};
